module.exports = __webpack_public_path__ + "static/img/advantage4.444bd8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/advantage4.png
// module id = A5Gu
// module chunks = 0